import {
  ThemeUICSSObject,
  getColorsAndStatesByPath,
  responsive,
  spacing,
} from '@apia/theme';
/* IMPORT HERE */

const list: ThemeUICSSObject = {
  '.ApiaFilter__Range': {
    backgroundColor: 'disabled',
    display: 'flex',
    alignItems: 'center',
  },
  '.freeMetaFilterPair': {
    display: 'flex',
    gap: '3',
    alignItems: 'center',
  },
  '.twoColumns': {
    gridColumn: responsive({ 0: '1', 2: '1' }),
    gap: spacing(3),
  },
  '&.validationFormTraMetadataFilters': {
    gridColumn: responsive({ 0: '1', 2: '1/3' }),
  },
  '.addFreeMetaFilter__Button': {
    marginTop: '8px',
  },
  '.removeFreeMetaFilter__Button': {
    cursor: 'pointer',
    borderRadius: 'buttons',

    ...getColorsAndStatesByPath('buttons.close'),
  },
  '.removeFreeMetaFilter__Box': {
    minWidth: '32px',
  },
};

export default list;
